import React, {useEffect, useState} from 'react';

// tremor
import { Callout, Card, Text, Metric } from "@tremor/react";

// icons
import { IoCheckmarkCircleOutline } from "react-icons/io5";

const SuccessMessage = (props) => {

    return (
        <Callout
            className="h-12 mt-4"
            title={props.title}
            icon={IoCheckmarkCircleOutline}
            color="teal"
            text={props.children}
        >
        </Callout>
    );
};

export default SuccessMessage;
